import { render, staticRenderFns } from "./tableWrapper.vue?vue&type=template&id=eba8bc0c&scoped=true&"
import script from "./tableWrapper.vue?vue&type=script&lang=ts&"
export * from "./tableWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./tableWrapper.vue?vue&type=style&index=0&id=eba8bc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba8bc0c",
  null
  
)

export default component.exports